export default __webpack_public_path__ + "static/media/search.a75bc596.png";